const isProduction = process.env.NODE_ENV === 'production';

export const editorPath = `${process.env.SURVEY_URL}editor`;

export const crmApiUrl = `${process.env.CRM_URL}/v1/`;
export const crmApiV3Url = `${process.env.CRM_URL}/v3/`;
export const straightApiUrl = `${process.env.BASE_URL}/`;
export const apiUrl = `${process.env.BASE_URL}/v1/`;
export const apiV2Url = `${process.env.BASE_URL}/v2/`;
export const apiV3Url = `${process.env.BASE_URL}/v3/`;
export const internalV2ApiUrl = `${process.env.INTERNAL_API_URL}/v2/`;
export const analyticsUrl = `${process.env.ANALYTICS_URL}/`;
export const staticUrl = '';

const getAbsoluteUrl = path => `${window.location.origin}${path}`;

export const logoutUrl = getAbsoluteUrl(
  `${isProduction ? '/Platform' : ''}/logout`,
);
export const loginUrl = getAbsoluteUrl(
  `${isProduction ? '/Platform' : ''}/login`,
);
export const dashboardUrl = getAbsoluteUrl('/');
export const rulesEngineUrl = getAbsoluteUrl('/apps/rules-engine/#/rules');
export const casesUrl = getAbsoluteUrl('/apps/agent/#/cases');
